import { useQuery } from "react-query";
import axios from "services/axiosInstance";
import { trace, context, SpanStatusCode } from "@opentelemetry/api";

export const useFetchData = (
  key = "key",
  url,
  successCallback,
  errorCallback,
  params = {},
  responseType = "json",
  enabled = false,
) => {
  const getCall = async (url) => {
    const tracer = trace.getTracer("oms-ui");
    // Start a span for the data fetch, parented to the current active context (e.g., a click)
    const span = tracer.startSpan(`fetch-data:${key}`, {
      attributes: {
        "http.url": url,
        "query.key": key,
      },
    });

    try {
      // Execute the request within the span's context to ensure auto-instrumentation picks it up as a child
      const response = await context.with(
        trace.setSpan(context.active(), span),
        () =>
          axios.get(url, {
            params,
            data: "",
            responseType,
          }),
      );

      span.setStatus({ code: SpanStatusCode.OK });
      return response;
    } catch (err) {
      span.recordException(err);
      span.setStatus({
        code: SpanStatusCode.ERROR,
        message: err.message,
      });
      throw err;
    } finally {
      span.end();
    }
  };

  const errorHandler = (err) => {
    //common error handling done
    errorCallback && errorCallback(err);
  };

  const successHandler = (res) => {
    //common success handling to be done
    successCallback && successCallback(res);
  };

  return useQuery(key, () => getCall(url), {
    onSuccess: (res) => successHandler(res),
    onError: (err) => errorHandler(err),
    enabled: enabled,
    retry: false,
  });
};
